export default __webpack_public_path__ + "static/media/organ_organo_1.a13c2fab.png";